import React, { Component } from 'react';
import WorksAtChips from '../multiLocation/WorksAtChips';
import AccessSection from '../permissions/AccessSection';
import { gate, can, getAccess, isOwnerHere } from '../permissions/access';
import { PERMISSIONS_VISIBLE } from '../../config/featureFlags';
import { connect } from 'react-redux';
import {hairdresserActions, paymentActions} from "../../_actions";
import { hairdresserService } from "../../_services";
import siteSetting from "../../config/env";
import Select from "react-select";
import PhoneInput,{isValidPhoneNumber} from 'react-phone-number-input';

import ReactCountryFlagsCurrencySelect from "react-country-flag-currency-picker";
import Switch from "react-switch";
import heic2any from "heic2any";

import { Close, InfoIcon, MySpinner } from '../SvgIcon';
import SlidePanel from '../shared/SlidePanel';
import './EditStaff.css';

const options = [
    { value: '1', label: 'Employed' },
    { value: '2', label: 'Self-Employed' },
];

class EditStaff extends Component {

    constructor(props){
        super(props);

        this.state = {
            name:'',
            first_name:'',
            last_name:'',
            email:'',
            phoneNumber:'',
            jobTitle:'',
            hairdresserBookingInterval:'',
            // Online booking optimisation strategy:
            //   'standard'  → grid only (clean times, may leave gaps)
            //   'reduce'    → grid + tight slot after each booking (default)
            //   'maximise'  → only back-to-back slots, no standard grid
            slotPacking: 'reduce',
            // Whether clients can book this person online. Absent means enabled,
            // so an existing team member is never shown as closed by default.
            onlineBookingEnabled: true,
            shortBio:'',
            circleImagePrev:require('../../assets/images/user-placeholder.png'),
            circleImage:require('../../assets/images/user-placeholder.png'),
            countryId:'217',
            salonId:localStorage.getItem('salonId'),
            employmentTypeId:1,
            employmentType:{ value: '1', label: 'Employed' },
            removeStaffMember:false,
            showMoreMenu: false,
            currencyCountry:"GB",
            currencySymbol:"£",
            currency:"GBP",
            salonCommissionRateStatus:false,
            productCommissionRateStatus:false,
            voucherCommissionRateStatus:false,
            salonCommissionRate:'',
            productCommissionRate:'',
            voucherCommissionRate:'',
            totalPayment:siteSetting.stripe.salonMonthlyPrice+siteSetting.stripe.oneSelfEmpPrice,
            totalPaymentBefore:siteSetting.stripe.salonMonthlyPrice+siteSetting.stripe.oneSelfEmpPrice,
            planPrice:siteSetting.stripe.salonMonthlyPrice,
            planType:"month",
            subscriptionInfo:{},
            oneSelfEmpPrice:siteSetting.stripe.oneSelfEmpPrice,
            oneSelfEmpPriceBefore:siteSetting.stripe.oneSelfEmpPrice,
            quantity:0,
            commissionPopup: false,
            isSalonOwner: null,
            mode: 'view',
            staffMenuOpen: false,
            dataLoaded: false,
            // Portfolio (own profile only)
            portfolio: [],
            portfolioUploading: false,
            deletingImageId: null,
            portfolioError: '',
        }
        // Seed the header from the list row (name, photo, role) so the panel
        // opens with the person visible instead of a full skeleton. The
        // edit-info response overwrites all of this when it lands.
        const seed = this.props.initialStaff;
        if (seed) {
            const info = seed.hairdresserInfo || {};
            const parts = String(seed.name || '').trim().split(/\s+/);
            const first = seed.first_name || parts[0] || '';
            const last = seed.last_name || (seed.first_name ? '' : parts.slice(1).join(' '));
            this.state.first_name = first;
            this.state.last_name = last;
            this.state.jobTitle = info.jobTitle || '';
            this.state.employmentTypeId = info.employmentTypeId;
            this.state.employmentType = info.employmentTypeId === 1 ? { value: '1', label: 'Employed' } : { value: '2', label: 'Self-Employed' };
            this.state.isSalonOwner = info.isSalonOwner || 0;
            if (seed.userImage && seed.userImage.circleImage) this.state.circleImagePrev = seed.userImage.circleImage;
            this.state.headerReady = true;
        }
        this.editStaff=this.editStaff.bind(this);
        this.onChanged=this.onChanged.bind(this);
        this.onDataChange=this.onDataChange.bind(this);
        this.validateEmail=this.validateEmail.bind(this);
        this.getPhoneNumber=this.getPhoneNumber.bind(this);
        this.removeStaff=this.removeStaff.bind(this);
        this.slidePanelRef = React.createRef();
    }

    handleFocusScroll = (e) => {
        setTimeout(() => {
            e.target.scrollIntoView({ behavior: 'smooth', block: 'center' });
        }, 300);
    }

    componentDidMount() {
        // On mobile, scroll focused inputs into view above keyboard
        if (window.innerWidth < 768) {
            this._focusHandler = (e) => {
                if (e.target.matches('input, textarea, select')) {
                    this.handleFocusScroll(e);
                }
            };
            document.addEventListener('focusin', this._focusHandler);
        }

        let employmentType={};
        var self = this;
        if (localStorage.getItem('accessToken')) {
            self.subscriptionGet();
            let params={
                hairdresserId: this.props.staffId || this.props.match?.params?.id,
                lastName:'',
                email:'',
                jobTitle:'',
                phoneNumber:''
            }
            params.latitude = siteSetting.default_latitude;
            params.longitude = siteSetting.default_longitude;
            // Use the v2 /edit-info endpoint instead of the legacy v1
            // bookingProfile call. Response shape is identical for the
            // fields this modal consumes (userInfo.{first_name, email, ...,
            // hairdresser.{slotPacking, hairdresserBookingInterval, ...}}).
            self.props.dispatch(hairdresserActions.getStaffEditInfoV2(params))
                .then(function (response) {
                    // v2 endpoints wrap under `responseData`; v1 used `data`.
                    // Accept either so this block survives any future endpoint
                    // shape changes.
                    const payload = response.data?.responseData || response.data?.data;
                    if(payload && payload.userInfo?.hairdresser) {
                        if(payload.userInfo.hairdresser.employmentTypeId===1){
                            employmentType={ value: '1', label: 'Employed' }
                        }else{
                            employmentType={ value: '2', label: 'Self-Employed' }
                        }
                        let phoneNumber=payload.userInfo.phoneNumber?self.getPhoneNumber(payload.userInfo.phoneNumber):"";
                        //console.log("phoneNumber",phoneNumber);
                        self.setState(
                            {
                                employmentTypeId:payload.userInfo.hairdresser.employmentTypeId,
                                employmentType:employmentType,
                                first_name: payload.userInfo.first_name&&payload.userInfo.first_name!==""?payload.userInfo.first_name:payload.userInfo.name,
                                last_name:payload.userInfo.last_name,
                                email: payload.userInfo.email,
                                phoneNumber: phoneNumber,
                                jobTitle: payload.userInfo.hairdresser.jobTitle,
                                hairdresserBookingInterval:payload.userInfo.hairdresser.hairdresserBookingInterval,
                                slotPacking: payload.userInfo.hairdresser.slotPacking || 'reduce',
                                // Absent means enabled — see the state default.
                                onlineBookingEnabled: payload.userInfo.hairdresser.onlineBookingEnabled !== false,
                                shortBio: payload.userInfo.hairdresser.shortBio,
                                circleImagePrev:payload.userInfo.userImage?.circleImage?payload.userInfo.userImage.circleImage:require('../../assets/images/user-placeholder.png'),
                                currency:payload.userInfo.hairdresser.currency?payload.userInfo.hairdresser.currency:"",
                                currencySymbol:payload.userInfo.hairdresser.currencySymbol?payload.userInfo.hairdresser.currencySymbol:"£",
                                currencyCountry:payload.userInfo.hairdresser.currencyCountry?payload.userInfo.hairdresser.currencyCountry:"GB",
                                salonCommissionRate:payload.userInfo.hairdresser.salonCommissionRate?payload.userInfo.hairdresser.salonCommissionRate:"",
                                productCommissionRate:payload.userInfo.hairdresser.productCommissionRate?payload.userInfo.hairdresser.productCommissionRate:"",
                                voucherCommissionRate:payload.userInfo.hairdresser.voucherCommissionRate?payload.userInfo.hairdresser.voucherCommissionRate:"",
                                salonCommissionRateStatus:payload.userInfo.hairdresser.salonCommissionRate?payload.userInfo.hairdresser.salonCommissionRate>0?true:false:false,
                                productCommissionRateStatus: payload.userInfo.hairdresser.productCommissionRate?payload.userInfo.hairdresser.productCommissionRate>0?true:false:false,
                                voucherCommissionRateStatus: payload.userInfo.hairdresser.voucherCommissionRate?payload.userInfo.hairdresser.voucherCommissionRate>0?true:false:false,
                                isSalonOwner: payload.userInfo.hairdresser.isSalonOwner || 0,
                                dataLoaded: true,
                            }
                        )
                        let currencyCountry=payload.userInfo.hairdresser.currencyCountry?payload.userInfo.hairdresser.currencyCountry:"GB"
                        if (self.refs.userCurrency) self.refs.userCurrency.updateSelected(currencyCountry)

                        // Load portfolio if editing own profile
                        if (self.isOwnProfile()) {
                            self.loadPortfolio();
                        }

                        // Auto-open delete modal if requested via initialAction
                        if (self.props.initialAction === 'delete' && !self.isOwnProfile()) {
                            self.handleRemoveStaffMember();
                        }
                    }
                })
        }else{
            this.props.history.push('/')
        }
    }

    componentWillUnmount() {
        if (this._focusHandler) {
            document.removeEventListener('focusin', this._focusHandler);
        }
        if (this._menuClickHandler) {
            document.removeEventListener('mousedown', this._menuClickHandler);
        }
    }

    componentDidUpdate(_, prevState) {
        if (this.state.staffMenuOpen && !prevState.staffMenuOpen) {
            this._menuClickHandler = (e) => {
                if (this._menuWrapRef && !this._menuWrapRef.contains(e.target)) {
                    this.setState({ staffMenuOpen: false });
                }
            };
            document.addEventListener('mousedown', this._menuClickHandler);
        } else if (!this.state.staffMenuOpen && prevState.staffMenuOpen) {
            if (this._menuClickHandler) {
                document.removeEventListener('mousedown', this._menuClickHandler);
            }
        }
    }

    subscriptionGet=()=>{
        let self=this;
        let data={

        }
        self.props.dispatch(paymentActions.subscriptionGet(data))
            .then(function (response) {
                console.log("response",response);
                if (response.data.statusCode===1) {
                    let subscriptionInfo=response.data.responseData.result
                    if(subscriptionInfo?.plan?.interval==="year"){
                        self.setState({
                            subscriptionInfo: subscriptionInfo,
                            planPrice:siteSetting.stripe.salonYearlyPrice,
                            totalPayment:siteSetting.stripe.salonYearlyPrice,
                            totalPaymentBefore:siteSetting.stripe.salonYearlyPrice,
                            planType:"year",
                            quantity:response.data.responseData?.selfEmpPlan?.quantity?response.data.responseData?.selfEmpPlan?.quantity:0
                        })
                    }else{
                        self.setState({
                            subscriptionInfo: subscriptionInfo,
                            quantity:response.data.responseData?.selfEmpPlan?.quantity?response.data.responseData?.selfEmpPlan?.quantity:0
                        })
                    }

                    // self.props.history.push('/staff')
                }else{
                    if (response.data.error.errorCode===3) {
                        self.setState({
                            emailError: response.data.error.responseMessage
                        })
                    }else{
                        self.setState({
                            emailError: response.data.error.responseMessage
                        })
                    }
                }
            })
    }

    editStaff(){
        this.setState({
            error:'',
            emailError:'',
            lNameError:'',
            fNameError:'',
            phoneNumberError:'',
            jobError:'',
            hairdresserBookingIntervalError:''
        })
        let self = this;
        let params = {};
        params.name=this.state.first_name+" "+this.state.last_name;
        params.first_name=this.state.first_name;
        params.last_name=this.state.last_name;
        params.email=this.state.email;
        params.phoneNumber=this.state.phoneNumber;
        params.jobTitle=this.state.jobTitle;
        params.hairdresserBookingInterval= this.state.hairdresserBookingInterval;
        params.shortBio=this.state.shortBio;
        params.employmentTypeId=this.state.employmentTypeId;
        params.salonId=this.state.salonId;
        params.countryId=this.state.countryId;

        if (this?.state?.first_name === "" || this?.state?.first_name === undefined) {
            this.setState({
                fNameError: self?.state.first_name!==''?'':'Please enter first name'
            })
        } else if (this.state.email === "" || this.state.email === undefined) {
            this.setState({
                emailError: self?.state.email!==''?'':"Please enter email address"
            })
        } else if (!this.validateEmail(this.state.email)) {
            this.setState({
                emailError: 'Please enter a valid email address'
            })
        } else if (this.state?.phoneNumber === "" || this.state.phoneNumber === undefined ) { //!isValidPhoneNumber(this.state.phoneNumber)
            this.setState({
                phoneNumberError: self?.state.phoneNumberError!==''?'':'Please enter a valid phone number'
            })
        } else if (this.state?.jobTitle === "" || this.state?.jobTitle === undefined) {
            this.setState({
                jobError: self?.state?.jobError!==''?'':'Please enter a job title'
            })
        }else if (this.state.hairdresserBookingInterval === "" || this.state.hairdresserBookingInterval === undefined) {
            this.setState({
                hairdresserBookingIntervalError: self?.state.hairdresserBookingIntervalError!==''?'dddddd':"Please enter Booking Intervals"
            })
        } else if (this.state?.hairdresserBookingInterval!=0 && this.state?.hairdresserBookingInterval%5!=0) {
            this.setState({
                hairdresserBookingIntervalError: 'Booking Interval Must be multiple of 5.'
            })
        } else if (this.state.salonCommissionRateStatus === true && (this.state.salonCommissionRate === '' || this.state.salonCommissionRate === null || this.state.salonCommissionRate < 0 || this.state.salonCommissionRate >100)) {
            this.setState({
                salonCommissionRateError: 'Commission should be between 1 to 100'
            })
        }else if (this.state.productCommissionRateStatus === true && (this.state.productCommissionRate === '' || this.state.productCommissionRate === null || this.state.productCommissionRate < 0 || this.state.productCommissionRate >100)) {
            this.setState({
                productCommissionRateError: 'Commission should be between 1 to 100'
            })
        }else if (this.state.voucherCommissionRateStatus === true && (this.state.voucherCommissionRate === '' || this.state.voucherCommissionRate === null || this.state.voucherCommissionRate < 0 || this.state.voucherCommissionRate >100)) {
            this.setState({
                voucherCommissionRateError: 'Commission should be between 1 to 100'
            })
        }
        // else if (this.state.shortBio === "" || this.state.shortBio === undefined) {
        //     this.setState({
        //         shortBioError: 'Please enter a short bio'
        //     })
        // }
        else {
            let data = new FormData();
            data.append('userId', (this.props.staffId || this.props.match?.params?.id));
            data.append('name', this.state.first_name+" "+this.state.last_name);
            data.append('first_name', this.state.first_name);
            data.append('last_name', this.state.last_name);
            data.append('email', this.state.email);
            data.append('phoneNumber', this.state.phoneNumber);
            data.append('jobTitle', this.state.jobTitle);
            data.append('hairdresserBookingInterval', this.state.hairdresserBookingInterval);
            data.append('slotPacking', this.state.slotPacking || 'reduce');
            data.append('onlineBookingEnabled', this.state.onlineBookingEnabled);
            data.append('shortBio', this.state.shortBio);
            // Employment type and commission route money: the owner's to set.
            // Anyone else leaves them out (the server keeps the current values).
            if (isOwnerHere()) data.append('employmentTypeId', this.state.employmentTypeId);
            data.append('salonId', this.state.salonId);
            data.append('countryId', this.state.countryId);
            data.append('circleImage', this.state.circleImage);
            data.append('rectangleImage', this.state.circleImage);
            data.append('currency', this.state.currency);
            data.append('currencySymbol', this.state.currencySymbol);
            data.append('currencyCountry', this.state.currencyCountry);
            if (isOwnerHere()) {
                data.append('salonCommissionRate', this.state.salonCommissionRate!=''?this.state.salonCommissionRate:0);
                data.append('productCommissionRate', this.state.productCommissionRate!=''?this.state.productCommissionRate:0);
                data.append('voucherCommissionRate', this.state.voucherCommissionRate!=''?this.state.voucherCommissionRate:0);
            }

            self.props.dispatch(hairdresserActions.editStaff(data))
                .then(function (response) {
                    //console.log('client response', response);

                    if (response.data.errorCode) {
                        if(response.data.errorCode===51){
                            self.setState({
                                emailError: response.data.messages
                            })
                        }else if(response.data.errorCode===57){
                            self.setState({
                                phoneNumberError: response.data.messages
                            })
                        }else{
                            self.setState({
                                error: response.data.messages
                            })
                        }

                    } else {
                        self.triggerClose(true);
                    }
                })
                .catch((err) => {
                    console.log("errr",err);
                })
        }
    }

    onChanged(e) {
        this.setState({ [e.target.name]: e.target.value, copied: false });

        if (e.target.name === 'email') {
            if (!this.validateEmail(e.target.value)) {
                this.setState({
                    emailError: 'Please enter a valid email address'
                })
            } else {
                this.setState({
                    emailError: ''
                })
            }
        }

        if (e.target.name === 'first_name') {
            if (e.target.value === '' || e.target.value === null) {
                this.setState({
                    fNameError: ''
                })
            } else {
                this.setState({
                    fNameError: '',
                })
            }
        }

        if (e.target.name === 'last_name') {
            if (e.target.value === '' || e.target.value === null) {
                this.setState({
                    lNameError: ''
                })
            } else {
                this.setState({
                    lNameError: '',
                })
            }
        }

        if (e.target.name === 'phoneNumber') {
            if (e.target.value.length!==10) {
                this.setState({
                    phoneNumberError: 'Please enter a valid phone number'
                })
            } else {
                this.setState({
                    phoneNumberError: '',
                })
            }
        }

        if (e.target.name === 'jobTitle') {
            if (e.target.value === '' || e.target.value === null) {
                this.setState({
                    jobError: ''
                })
            } else {
                this.setState({
                    jobError: '',
                })
            }
        }
        if (e.target.name === 'hairdresserBookingInterval') {
            if (!e.target.value!=0 && e.target.value%5!=0) {
                this.setState({
                    hairdresserBookingIntervalError: 'Booking Interval Must be multiple of 5.'
                })
            } else {
                this.setState({
                    hairdresserBookingIntervalError: ''
                })
            }
        }
        // if (e.target.name === 'shortBio') {
        //     if (e.target.value === '' || e.target.value === null||e.target.value.length<10) {
        //         this.setState({
        //             shortBioError: 'The shortBio must be at least 10 characters.'
        //         })
        //     } else {
        //         this.setState({
        //             shortBioError: '',
        //         })
        //     }
        // }

        if (e.target.name === 'salonCommissionRate'){
            if (e.target.value === '' || e.target.value === null || e.target.value < 0 || e.target.value >100) {
                this.setState({
                    salonCommissionRateError: 'Commission should be between 1 to 100'
                })
            } else {
                this.setState({
                    salonCommissionRateError: '',
                })
            }
        }

        if (e.target.name === 'productCommissionRate'){
            if (e.target.value === '' || e.target.value === null || e.target.value < 0 || e.target.value >100) {
                this.setState({
                    productCommissionRateError: 'Commission should be between 1 to 100'
                })
            } else {
                this.setState({
                    productCommissionRateError: '',
                })
            }
        }

        if (e.target.name === 'voucherCommissionRate'){
            if (e.target.value === '' || e.target.value === null || e.target.value < 0 || e.target.value >100) {
                this.setState({
                    voucherCommissionRateError: 'Commission should be between 1 to 100'
                })
            } else {
                this.setState({
                    voucherCommissionRateError: '',
                })
            }
        }

        if (e.target.name === 'circleImage') {
            // console.log("e",e);
            let reader = new FileReader();
            let file = e.target.files[0];

            reader.onloadend = () => {
                this.setState({
                    circleImagePrev: reader.result
                });
            }
            reader.readAsDataURL(file)


            this.setState({
                circleImagePrev: file
            })
            this.setState({
                circleImage: e.target.files[0]
            });
        }
    }

    onDataChange(value, action){
        this.setState({
            [action.name]: value,
            employmentTypeId:value.value
        })
    }

    validateEmail(email) {
        const pattern = /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        const result = pattern.test(email);
        return result;
    }

    triggerClose = (didSave = false) => {
        this._didSave = didSave;
        if (this.slidePanelRef.current) this.slidePanelRef.current.handleClose();
    }

    handlePanelClose = () => {
        if (this.props.onClose) {
            this.props.onClose(this._didSave || false);
        } else {
            this.props.history.push('/staff');
        }
        this._didSave = false;
    }

    handlePhoneChange = val => {
        this.setState({phoneNumber: val})
        // if(!isValidPhoneNumber(val)) {
        //     this.setState({
        //         phoneNumberError: 'Please enter a valid phone number'
        //     })
        // }
    }

    getPhoneNumber(phoneNumber){
        let phone=phoneNumber.toString()
        //console.log("phone",phone);
        if(phone.length===10){
            //console.log("phone1",phone);
            if (phone[0] === 0||phone[0] === "0") {
                //console.log("phone1.1",phone);
                return "+44"+phone.substr(1)
            }else{
                //console.log("phone1.2",phone);
                return "+44"+phone
            }
        }else {
            //console.log("phone2",phone);
            if (phone[0] === 0||phone[0] === "0") {
                //console.log("phone2.1",phone);
                return "+44"+phone.substr(1)
            } else if (phone[0] === 4||phone[0] === "4") {
                //console.log("phone2.2",phone);
                return "+" + phone
            } else {
                //console.log("phone2.3",phone);
                return "+44"+phone
            }
        }
    }

    removeStaff(){
        let self=this;
        let params={
            employeeId:(this.props.staffId || this.props.match?.params?.id),
            hairdresserId:localStorage.getItem('userId'),
            salonLeaveDate:''
        }
        self.props.dispatch(hairdresserActions.removeStaff(params))
            .then(function (removeStaff) {
                self.triggerClose(true);
            })
    }

    handleClose = () => this.setState({
        removeStaffMember: false,
    })

    handleRemoveStaffMember=()=>{
        this.setState({
            removeStaffMember:true
        })
    }

    onSelectCurrency=(country)=>{
        //console.log("country",country);
        this.setState({
            currency:country.currency,
            currencySymbol:country.symbol,
            currencyCountry:country.countryCode,
        })
    }

    isOwnProfile = () => {
        const staffId = this.props.staffId || this.props.match?.params?.id;
        const loggedInUserId = localStorage.getItem('userId');
        return staffId && loggedInUserId && staffId.toString() === loggedInUserId.toString();
    }

    loadPortfolio = async () => {
        try {
            const response = await hairdresserService.getProfileV2();
            if (response?.data?.responseData) {
                this.setState({
                    portfolio: response.data.responseData.portfolio || [],
                });
            }
        } catch (error) {
            console.error('Error loading portfolio:', error);
        }
    }

    handlePortfolioUpload = async (e) => {
        const file = e.target.files?.[0];
        if (!file) return;

        const validTypes = ['image/jpeg', 'image/jpg', 'image/png', 'image/gif', 'image/webp'];
        const isHeic = file.type === 'image/heic' || file.name.toLowerCase().endsWith('.heic');

        if (!validTypes.includes(file.type) && !isHeic) {
            this.setState({ portfolioError: 'Please select a valid image file (JPEG, PNG, GIF, WebP, or HEIC)' });
            return;
        }

        if (file.size > 10 * 1024 * 1024) {
            this.setState({ portfolioError: 'Image size must be less than 10MB' });
            return;
        }

        this.setState({ portfolioUploading: true, portfolioError: '' });

        try {
            let uploadFile = file;
            if (isHeic) {
                uploadFile = await heic2any({ blob: file, toType: 'image/jpeg' });
            }

            const response = await hairdresserService.uploadPortfolioImage(uploadFile);

            if (response?.data?.responseData) {
                this.setState(prevState => ({
                    portfolio: [...prevState.portfolio, response.data.responseData],
                    portfolioUploading: false,
                }));
            } else {
                throw new Error('Upload failed');
            }
        } catch (error) {
            console.error('Portfolio upload error:', error);
            this.setState({
                portfolioUploading: false,
                portfolioError: error.response?.data?.message || 'Failed to upload image. Please try again.',
            });
        }

        e.target.value = '';
    }

    handlePortfolioDelete = async (imageId) => {
        if (!imageId || !window.confirm('Are you sure you want to delete this portfolio image?')) {
            return;
        }

        this.setState({ deletingImageId: imageId });

        try {
            await hairdresserService.deletePortfolioImage(imageId);
            this.setState(prevState => ({
                portfolio: prevState.portfolio.filter(img => img._id !== imageId),
                deletingImageId: null,
            }));
        } catch (error) {
            console.error('Portfolio delete error:', error);
            this.setState({
                deletingImageId: null,
                portfolioError: error.response?.data?.message || 'Failed to delete image. Please try again.',
            });
        }
    }

    onChangeSalonCommissionRate = (checked) => {
        this.setState({
            salonCommissionRateStatus:checked
        })
        if(!checked){
            this.setState({
                salonCommissionRate:''
            })
        }
    };

    onChangeProductCommissionRate = (checked) => {
        this.setState({
            productCommissionRateStatus:checked
        })
        if(!checked){
            this.setState({
                productCommissionRate:''
            })
        }
    };

    onChangeVoucherCommissionRate = (checked) => {
        this.setState({
            voucherCommissionRateStatus:checked
        })
        if(!checked){
            this.setState({
                voucherCommissionRate:''
            })
        }
    };

    closeCommissionPopup = () => {
        this.setState({ commissionPopup: false });
      };

      openCommissionPopup = ()=>{
        let self = this;
        self.setState({
            commissionPopup: true
        })
      }
      showTooltip=()=>{
        this.setState({
            showTooltip:true
        })
     }
     hideTooltip=()=>{
        this.setState({
            showTooltip:false
        })
     }
    renderProfileHeader() {
        const fullName = [this.state.first_name, this.state.last_name].filter(Boolean).join(' ') || 'Staff Member';
        const empLabel = this.state.employmentType?.label || 'Employed';
        return (
            <div className="es-profile-header">
                <div className="es-profile-avatar">
                    <img src={this.state.circleImagePrev} alt={fullName} />
                </div>
                <h3 className="es-profile-name">{fullName}</h3>
                <p className="es-profile-role">{this.state.jobTitle || 'Staff Member'}</p>
                <span className="es-profile-badge">{empLabel}</span>
            </div>
        );
    }

    renderViewSkeleton() {
        return (
            <>
                <div className="es-body">
                    {this.state.headerReady ? this.renderProfileHeader() : (
                        <div className="es-profile-header">
                            <div className="es-profile-avatar es-skeleton-pulse" style={{ background: '#f0f0f0' }} />
                            <div className="es-skeleton-pulse" style={{ width: 140, height: 18, borderRadius: 8, background: '#f0f0f0', marginBottom: 6 }} />
                            <div className="es-skeleton-pulse" style={{ width: 90, height: 14, borderRadius: 6, background: '#f0f0f0', marginBottom: 10 }} />
                            <div className="es-skeleton-pulse" style={{ width: 80, height: 24, borderRadius: 20, background: '#f0f0f0' }} />
                        </div>
                    )}
                    <div className="es-info-list">
                        {[1,2,3,4].map(i => (
                            <div className="es-info-item" key={i}>
                                <div className="es-skeleton-pulse" style={{ width: 70, height: 14, borderRadius: 6, background: '#f0f0f0' }} />
                                <div className="es-skeleton-pulse" style={{ width: 120, height: 14, borderRadius: 6, background: '#f0f0f0' }} />
                            </div>
                        ))}
                    </div>
                </div>
                <div className="es-footer es-footer--actions">
                    <div className="es-skeleton-pulse" style={{ flex: 1, height: 48, borderRadius: 12, background: '#f0f0f0' }} />
                </div>
            </>
        );
    }

    renderViewMode() {
        if (!this.state.dataLoaded) return this.renderViewSkeleton();

        const hasCommission = this.state.employmentTypeId !== 1;

        return (
            <>
                <div className="es-body">
                    {this.renderProfileHeader()}

                    {/* Info rows */}
                    <div className="es-info-list">
                        <div className="es-info-item">
                            <span className="es-info-label">Email</span>
                            <span className="es-info-value">{this.state.email || '-'}</span>
                        </div>
                        <div className="es-info-item">
                            <span className="es-info-label">Phone</span>
                            <span className="es-info-value">{this.state.phoneNumber || '-'}</span>
                        </div>
                        <div className="es-info-item">
                            <span className="es-info-label">Booking Interval</span>
                            <span className="es-info-value">{this.state.hairdresserBookingInterval ? `${this.state.hairdresserBookingInterval} min` : '-'}</span>
                        </div>
                        <div className="es-info-item">
                            <span className="es-info-label">How clients see your online times</span>
                            <span className="es-info-value">
                                {this.state.slotPacking === 'standard' && 'Round times only'}
                                {(this.state.slotPacking === 'reduce' || !this.state.slotPacking) && 'Round times + fill gaps'}
                                {this.state.slotPacking === 'maximise' && 'Pack back-to-back'}
                            </span>
                        </div>
                        <div className="es-info-item">
                            <span className="es-info-label">Currency</span>
                            <span className="es-info-value">{this.state.currencySymbol} ({this.state.currency})</span>
                        </div>
                        {this.state.shortBio && (
                            <div className="es-info-item es-info-item--block">
                                <span className="es-info-label">Bio</span>
                                <span className="es-info-value">{this.state.shortBio}</span>
                            </div>
                        )}
                        {hasCommission && (
                            <>
                                <div className="es-info-item">
                                    <span className="es-info-label">Booking Commission</span>
                                    <span className="es-info-value">{this.state.salonCommissionRate || 0}%</span>
                                </div>
                                <div className="es-info-item">
                                    <span className="es-info-label">Product Commission</span>
                                    <span className="es-info-value">{this.state.productCommissionRate || 0}%</span>
                                </div>
                                <div className="es-info-item">
                                    <span className="es-info-label">Voucher Commission</span>
                                    <span className="es-info-value">{this.state.voucherCommissionRate || 0}%</span>
                                </div>
                            </>
                        )}

                    </div>

                    {/* Access: role, and where it applies — for people who manage the team or access */}
                    {PERMISSIONS_VISIBLE && (can('team') || can('permissions')) && (
                        <AccessSection
                            userId={String(this.props.staffId || this.props.match?.params?.id || '')}
                            firstName={this.state.first_name || (this.state.name || '').split(' ')[0]}
                            employmentTypeId={this.state.employmentTypeId}
                            isProfileOwner={this.state.isSalonOwner === 1}
                            isOwnProfile={this.isOwnProfile()}
                        />
                    )}

                    <div className="es-info-list">
                        {/* Portfolio (own profile only) */}
                        {this.isOwnProfile() && this.state.portfolio.length > 0 && (
                            <div className="es-info-item es-info-item--block">
                                <span className="es-info-label">Portfolio</span>
                                <div className="es-portfolio-grid">
                                    {this.state.portfolio.map((image) => (
                                        <div key={image._id} className="es-portfolio-item">
                                            <img src={image.imageUrl} alt="Portfolio" />
                                        </div>
                                    ))}
                                </div>
                            </div>
                        )}

                    </div>
                </div>

            </>
        );
    }

    renderEditMode() {
        // Help copy is interval-aware: the example reflects THIS stylist's
        // Booking Interval (the field directly above). reduce uses the same
        // interval grid as standard (+ fillers), so it's framed that way;
        // only maximise drops the grid, so its copy says the interval no
        // longer applies.
        const iv = parseInt(this.state.hairdresserBookingInterval, 10) || 0;
        const ivFmt = (m) => `${Math.floor(m / 60)}:${String(m % 60).padStart(2, '0')}`;
        const ivPhrase = iv
            ? `round times every ${iv} min (e.g. ${ivFmt(540)}, ${ivFmt(540 + iv)}, ${ivFmt(540 + 2 * iv)})`
            : 'round times set by your Booking Interval';
        const slotPackingHelp = {
            standard: `Clients only see ${ivPhrase}, from the Booking Interval above. Tidy, but can leave gaps between appointments.`,
            reduce: `The same ${ivPhrase} as Standard, plus a slot right after each appointment so clients fill the gaps (e.g. straight after your 10:00 cut). Best for most stylists.`,
            maximise: 'Clients only see times tight against your existing bookings and the start/end of your day. No gaps, but fewer choices for clients, and your Booking Interval no longer applies. Use when you’re nearly fully booked.',
        };
        return (
            <>
                <div className="es-body">
                    <div className="es-avatar-section">
                        <div className="es-avatar" onClick={() => this.circleImage.click()}>
                            <img src={this.state.circleImagePrev} alt="staff" />
                            <div className="es-avatar-badge">
                                <svg width="12" height="12" viewBox="0 0 12 12" fill="none"><path d="M6 2.5v7M2.5 6h7" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round"/></svg>
                            </div>
                        </div>
                        <input type="file" ref={(ref) => this.circleImage = ref} name="circleImage" id="circleImage" onChange={this.onChanged} style={{display:'none'}} />
                    </div>

                    <div className="es-form">
                        <div className="es-row">
                            <div className="es-field">
                                <label className="es-label">First Name</label>
                                <input type="text" className="es-input" value={this.state.first_name} name="first_name" onChange={this.onChanged} />
                                {this.state.fNameError && <span className="es-error">{this.state.fNameError}</span>}
                            </div>
                            <div className="es-field">
                                <label className="es-label">Surname</label>
                                <input type="text" className="es-input" value={this.state.last_name} name="last_name" onChange={this.onChanged} />
                                {this.state.lNameError && <span className="es-error">{this.state.lNameError}</span>}
                            </div>
                        </div>

                        <div className="es-row">
                            <div className="es-field">
                                <label className="es-label">Email</label>
                                <input type="email" className="es-input" value={this.state.email} name="email" onChange={this.onChanged} />
                                {this.state.emailError && <span className="es-error">{this.state.emailError}</span>}
                            </div>
                            <div className="es-field">
                                <label className="es-label">Mobile Number</label>
                                <PhoneInput
                                    international={true}
                                    defaultCountry="GB"
                                    className="es-input es-phone-input"
                                    placeholder="Phone Number"
                                    name="phoneNumber"
                                    value={this.state.phoneNumber || ""}
                                    onChange={this.handlePhoneChange}
                                />
                                {this.state.phoneNumberError && <span className="es-error">{this.state.phoneNumberError}</span>}
                            </div>
                        </div>

                        <div className="es-row">
                            <div className="es-field">
                                <label className="es-label">Job Title</label>
                                <input type="text" className="es-input" value={this.state.jobTitle} name="jobTitle" onChange={this.onChanged} />
                                {this.state.jobError && <span className="es-error">{this.state.jobError}</span>}
                            </div>
                            <div className="es-field">
                                <label className="es-label">Employment Type</label>
                                <div className="es-static-value">{this.state.employmentType?.label || 'Employed'}</div>
                            </div>
                        </div>
                        {/* Multi-location: Works at (renders nothing for single-site salons) */}
                        <div className="es-row"><WorksAtChips userId={this.props.staffId || this.props.match?.params?.id} /></div>

                        <div className="es-row">
                            <div className="es-field">
                                <label className="es-label">Booking Interval</label>
                                <input type="text" className="es-input" value={this.state.hairdresserBookingInterval} name="hairdresserBookingInterval" onChange={this.onChanged} />
                                {this.state.hairdresserBookingIntervalError && <span className="es-error">{this.state.hairdresserBookingIntervalError}</span>}
                            </div>
                            <div className="es-field">
                                <label className="es-label">Currency</label>
                                <ReactCountryFlagsCurrencySelect
                                    className="form-control CurrencySelect"
                                    defaultCountry={this.state.currencyCountry}
                                    showOptionLabel={false}
                                    showCurrency={true}
                                    showCurrencySymbol={true}
                                    showSelectedLabel={false}
                                    onSelect={this.onSelectCurrency}
                                    ref="userCurrency"
                                />
                            </div>
                        </div>

                        <div className="es-field">
                            <label className="es-label">How clients see your online times</label>
                            <select
                                className="es-input"
                                value={this.state.slotPacking || 'reduce'}
                                name="slotPacking"
                                onChange={this.onChanged}
                            >
                                <option value="standard">Round times only</option>
                                <option value="reduce">Round times + fill gaps (recommended)</option>
                                <option value="maximise">Pack back-to-back (busy days)</option>
                            </select>
                            <span className="es-help">
                                {this.state.slotPacking === 'standard' && slotPackingHelp.standard}
                                {(this.state.slotPacking === 'reduce' || !this.state.slotPacking) && slotPackingHelp.reduce}
                                {this.state.slotPacking === 'maximise' && slotPackingHelp.maximise}
                            </span>
                        </div>

                        <div className="es-field">
                            <label className="es-label">Bio</label>
                            <textarea className="es-textarea" value={this.state.shortBio} name="shortBio" onChange={this.onChanged} rows="3" />
                            {this.state.shortBioError && <span className="es-error">{this.state.shortBioError}</span>}
                        </div>

                        {/* Portfolio (own profile only) */}
                        {this.isOwnProfile() && (
                            <div className="es-field">
                                <label className="es-label">Portfolio</label>
                                <div className="es-portfolio-grid">
                                    {this.state.portfolio.map((image) => (
                                        <div key={image._id} className="es-portfolio-item">
                                            <img src={image.imageUrl} alt="Portfolio" />
                                            <button
                                                type="button"
                                                className="es-portfolio-delete"
                                                onClick={() => this.handlePortfolioDelete(image._id)}
                                                disabled={this.state.deletingImageId === image._id}
                                            >
                                                {this.state.deletingImageId === image._id ? (
                                                    <MySpinner clsName="spinner-small" />
                                                ) : (
                                                    <svg width="10" height="10" viewBox="0 0 14 14" fill="none"><path d="M1 1L13 13M13 1L1 13" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/></svg>
                                                )}
                                            </button>
                                        </div>
                                    ))}
                                    <div
                                        className="es-portfolio-upload"
                                        onClick={() => !this.state.portfolioUploading && this.portfolioInput?.click()}
                                    >
                                        {this.state.portfolioUploading ? (
                                            <MySpinner clsName="spinner-medium" />
                                        ) : (
                                            <>
                                                <svg width="20" height="20" viewBox="0 0 20 20" fill="none"><path d="M10 4v12M4 10h12" stroke="#999" strokeWidth="1.5" strokeLinecap="round"/></svg>
                                                <span style={{ fontSize: 11, color: '#999', marginTop: 4 }}>Add Image</span>
                                            </>
                                        )}
                                        <input
                                            ref={ref => this.portfolioInput = ref}
                                            type="file"
                                            accept="image/*, .heic"
                                            onChange={this.handlePortfolioUpload}
                                            style={{ display: 'none' }}
                                        />
                                    </div>
                                </div>
                                {this.state.portfolioError && <span className="es-error">{this.state.portfolioError}</span>}
                            </div>
                        )}

                        {/* Online booking — for EVERY staff member, not just the
                            self-employed: a manager needs to pause a new junior
                            just as much. The same field the professional sets on
                            their own booking settings page, so both sides see one
                            shared value rather than two that can disagree. */}
                        <div className="es-section-header">
                            <span>Online booking</span>
                        </div>
                        <div className="es-commission-card">
                            <div className="es-commission-item" style={{ borderBottom: 'none' }}>
                                <div className="es-commission-left">
                                    <span className="es-commission-name">Accept online bookings</span>
                                    <span className="es-commission-desc">
                                        {this.state.onlineBookingEnabled
                                            ? 'Clients can book this person online'
                                            : 'Paused: no new online bookings. The diary and existing bookings are unaffected.'}
                                    </span>
                                </div>
                                <div className="es-commission-right">
                                    <Switch
                                        onColor="#007EA0"
                                        onChange={(checked) => this.setState({ onlineBookingEnabled: checked })}
                                        checked={this.state.onlineBookingEnabled}
                                        height={24}
                                        width={44}
                                        handleDiameter={20}
                                    />
                                </div>
                            </div>
                        </div>

                        {this.state.employmentTypeId !== 1 && isOwnerHere() && ( /* commission + employment type: the owner's to set (money routing, never a role) */
                            <>
                                <div className="es-section-header">
                                    <span>Commissions</span>
                                    <button type="button" className="es-info-btn" onClick={this.showTooltip}>
                                        <InfoIcon />
                                    </button>
                                </div>
                                {!getAccess().owner && (
                                    /* Access audit 2026-10-02: commission and employment type
                                       are money routing — the server takes them from the owner only. */
                                    <p className="es-commission-desc" style={{ padding: '0 0 8px' }}>Only the salon owner can change commission rates.</p>
                                )}
                                {this.state.showTooltip && (
                                    <div className="es-info-box">
                                        <button type="button" className="es-info-close" onClick={this.hideTooltip}><Close /></button>
                                        <p><b>Service Commission</b> - paid to the salon manager by the self-employed staff member.</p>
                                        <p><b>Product Commission</b> - on profits, paid to the self-employed staff member.</p>
                                    </div>
                                )}
                                <div className="es-commission-card">
                                    <div className="es-commission-item">
                                        <div className="es-commission-left">
                                            <span className="es-commission-name">Booking</span>
                                            <span className="es-commission-desc">Paid to salon manager</span>
                                        </div>
                                        <div className="es-commission-right">
                                            <Switch onColor="#007EA0" onChange={this.onChangeSalonCommissionRate} checked={this.state.salonCommissionRateStatus} disabled={!getAccess().owner} height={24} width={44} handleDiameter={20} />
                                            {this.state.salonCommissionRateStatus && (
                                                <div className="es-commission-input-wrap">
                                                    <input type="number" className="es-input es-commission-input" value={this.state.salonCommissionRate} name="salonCommissionRate" onChange={this.onChanged} placeholder="0" disabled={!getAccess().owner} />
                                                    <span className="es-commission-unit">%</span>
                                                </div>
                                            )}
                                        </div>
                                    </div>
                                    {this.state.salonCommissionRateError && <span className="es-error" style={{ padding: '0 16px 8px' }}>{this.state.salonCommissionRateError}</span>}

                                    <div className="es-commission-item">
                                        <div className="es-commission-left">
                                            <span className="es-commission-name">Product</span>
                                            <span className="es-commission-desc">On profits, paid to staff</span>
                                        </div>
                                        <div className="es-commission-right">
                                            <Switch onColor="#007EA0" onChange={this.onChangeProductCommissionRate} checked={this.state.productCommissionRateStatus} disabled={!getAccess().owner} height={24} width={44} handleDiameter={20} />
                                            {this.state.productCommissionRateStatus && (
                                                <div className="es-commission-input-wrap">
                                                    <input type="number" className="es-input es-commission-input" value={this.state.productCommissionRate} name="productCommissionRate" onChange={this.onChanged} placeholder="0" disabled={!getAccess().owner} />
                                                    <span className="es-commission-unit">%</span>
                                                </div>
                                            )}
                                        </div>
                                    </div>
                                    {this.state.productCommissionRateError && <span className="es-error" style={{ padding: '0 16px 8px' }}>{this.state.productCommissionRateError}</span>}

                                    <div className="es-commission-item" style={{ borderBottom: 'none' }}>
                                        <div className="es-commission-left">
                                            <span className="es-commission-name">Voucher</span>
                                            <span className="es-commission-desc">Paid to staff member</span>
                                        </div>
                                        <div className="es-commission-right">
                                            <Switch onColor="#007EA0" onChange={this.onChangeVoucherCommissionRate} checked={this.state.voucherCommissionRateStatus} disabled={!getAccess().owner} height={24} width={44} handleDiameter={20} />
                                            {this.state.voucherCommissionRateStatus && (
                                                <div className="es-commission-input-wrap">
                                                    <input type="number" className="es-input es-commission-input" value={this.state.voucherCommissionRate} name="voucherCommissionRate" onChange={this.onChanged} placeholder="0" disabled={!getAccess().owner} />
                                                    <span className="es-commission-unit">%</span>
                                                </div>
                                            )}
                                        </div>
                                    </div>
                                    {this.state.voucherCommissionRateError && <span className="es-error" style={{ padding: '0 16px 8px' }}>{this.state.voucherCommissionRateError}</span>}
                                </div>
                            </>
                        )}
                    </div>
                </div>

                <div className="es-footer es-footer--edit">
                    <button className="es-btn-secondary" onClick={() => this.setState({ mode: 'view' })} type="button">Cancel</button>
                    <button className="es-btn-primary" onClick={this.editStaff.bind(this)} type="button">Save</button>
                </div>
            </>
        );
    }

    render() {
        let { removeStaffMember, mode } = this.state;
        const isEdit = mode === 'edit';

        const headerContent = (
            <>
                <div className="es-header">
                    <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                        {isEdit && (
                            <button className="es-back-btn" onClick={() => this.setState({ mode: 'view' })} type="button">
                                <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                                    <polyline points="15 18 9 12 15 6"/>
                                </svg>
                            </button>
                        )}
                        <h2 className="es-header-title">{isEdit ? (this.props.inline ? 'Edit Profile' : 'Edit Staff') : (this.state.dataLoaded ? this.state.first_name || 'Staff' : '')}</h2>
                    </div>
                    <div className="es-header-actions">
                        {!isEdit && this.state.dataLoaded && (this.isOwnProfile() || can('team')) && (
                            <div className="es-menu-wrap" ref={el => this._menuWrapRef = el}>
                                <button className="es-kebab-btn" onClick={() => this.setState(prev => ({ staffMenuOpen: !prev.staffMenuOpen }))} type="button" title="Options">
                                    <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round">
                                        <circle cx="12" cy="5" r="1"/><circle cx="12" cy="12" r="1"/><circle cx="12" cy="19" r="1"/>
                                    </svg>
                                </button>
                                {this.state.staffMenuOpen && (
                                    <div className="es-menu-dropdown">
                                        <button className="es-menu-item" onClick={() => { this.setState({ staffMenuOpen: false, mode: 'edit' }); }}>
                                            <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.4" strokeLinecap="round" strokeLinejoin="round">
                                                <path d="M11 4H4a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-7" /><path d="M18.5 2.5a2.121 2.121 0 0 1 3 3L12 15l-4 1 1-4 9.5-9.5z" />
                                            </svg>
                                            Edit
                                        </button>
                                        {!this.isOwnProfile() && this.state.isSalonOwner !== 1 && can('team') && (
                                            <>
                                                <div style={{ height: 1, background: '#f0f0f2' }} />
                                                <button className="es-menu-item es-menu-item--danger" onClick={() => { this.setState({ staffMenuOpen: false }); this.handleRemoveStaffMember(); }}>
                                                    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.4" strokeLinecap="round" strokeLinejoin="round">
                                                        <polyline points="3 6 5 6 21 6" /><path d="M19 6v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6m3 0V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2" />
                                                    </svg>
                                                    Remove Staff Member
                                                </button>
                                            </>
                                        )}
                                    </div>
                                )}
                            </div>
                        )}
                        {!this.props.inline && (
                            <button className="es-close-btn" onClick={() => { if (this.slidePanelRef.current) this.slidePanelRef.current.handleClose(); }} type="button">
                                <svg width="14" height="14" viewBox="0 0 14 14" fill="none">
                                    <path d="M1 1L13 13M13 1L1 13" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round"/>
                                </svg>
                            </button>
                        )}
                    </div>
                </div>
                {isEdit ? this.renderEditMode() : this.renderViewMode()}
            </>
        );

        if (this.props.inline) {
            return (
                <>
                    <div className="es-inline-container">
                        {headerContent}
                    </div>
                </>
            );
        }

        return (
            <>
                <SlidePanel ref={this.slidePanelRef} onClose={this.handlePanelClose}>
                    {headerContent}
                </SlidePanel>

                {removeStaffMember && (
                <div className="es-confirm-overlay" onClick={this.handleClose}>
                    <div className="es-confirm-card" onClick={e => e.stopPropagation()}>
                        <div className="es-confirm-icon">
                            <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
                                <path d="M12 9v4m0 4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z" stroke="#DC2626" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                            </svg>
                        </div>
                        <h3 className="es-confirm-title">Remove Staff Member</h3>
                        <p className="es-confirm-text">
                            This will remove {this.state.first_name || 'this staff member'} from the salon and cancel all their bookings. Clients will be notified via email.
                            {this.state.employmentType.label === 'Employed'
                                ? ' Your subscription fee remains unchanged.'
                                : ' Your subscription may change as follows:'}
                        </p>
                        {this.state.employmentType.label !== 'Employed' && (
                            <div className="es-confirm-plans">
                                <div className="es-confirm-plan">
                                    <span className="es-confirm-plan-label">Current Plan</span>
                                    <span className="es-confirm-plan-value">{this.state.quantity > 0 ? `Business Plan + ${this.state.quantity} Self Employed` : "Business Plan"}</span>
                                </div>
                                <div className="es-confirm-plan">
                                    <span className="es-confirm-plan-label">New Plan</span>
                                    <span className="es-confirm-plan-value">{this.state.quantity > 1 ? `Business Plan + ${this.state.quantity - 1} Self Employed` : "Business Plan"}</span>
                                </div>
                            </div>
                        )}
                        <div className="es-confirm-actions">
                            <button className="es-btn-secondary" onClick={this.handleClose}>Cancel</button>
                            <button className="es-btn-delete" onClick={this.removeStaff.bind(this)}>Remove</button>
                        </div>
                    </div>
                </div>
                )}
            </>
        );
    }
}



function mapStateToProps(state) {
    return {
        ...state
    };
}

export default connect(mapStateToProps)(EditStaff);





